import { Component, inject } from '@angular/core';
import { forkJoin } from 'rxjs';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReadService } from '@common/service/read.service';
import { AlertErrorService } from '@core/service/alert-error.service';
import { HabilitationService } from '@core/service/habilitation.service';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MultiSelectEditComponent } from '../multi-select/multi-select-edit.component';

@Component({
  standalone: true,
  selector: 'access-edit-dialog',
  templateUrl: './access-edit-dialog.component.html',
  imports: [CommonModule, FormsModule, NgbModule, MultiSelectEditComponent],
})
export class AccessEditComponent {
  readService = inject(ReadService);
  alertService = inject(AlertErrorService);

  habilitationParams: any = {};

  listRolesAAffecter: string[] = [];
  listRolesASupp: string[] = [];

  isSaving: boolean = false;

  roleIds: number[] = [];
  roles: any[] = [];

  constructor(
    private habilitationService: HabilitationService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.loadAll();
  }

  loadAll() {
    this.isSaving = false;
    this.loadAffectations();
  }

  loadAffectations() {
    forkJoin([
      this.readService.queryResult('ListRoleParRessourceIHM', {
        params: { code: this.habilitationParams.ressourceCode },
      }),
      this.readService.queryResult('ListRole'),
    ]).subscribe({
      next: ([affectedRoles, roles]) => {
        this.roleIds = affectedRoles.map((el: any) => el.id);
        this.roles = roles;
      },
    });
  }

  onRolesAssigned(assignedRoles: any[]) {
    if (assignedRoles?.length) {
      this.isSaving = true;
      const assignedRoleIds = assignedRoles.map((role) => role.id || role);
      this.habilitationService.affectationRolesEnMasse(this.habilitationParams.ressourceCode, 'TRS_IHM', assignedRoleIds, this.habilitationParams.module).subscribe(() => {
        this.alertService.showOperationSuccess();
        this.roleIds = [...this.roleIds, ...assignedRoleIds];

        this.loadAll();
      });
    }
  }

  onRolesUnassigned(unassignedRoles: any[]) {
    if (unassignedRoles?.length) {
      this.isSaving = true;
      const unassignedRoleIds = unassignedRoles.map((role) => role.id || role);
      this.habilitationService.suppAffectationRolesEnMasse(this.habilitationParams.ressourceCode, 'TRS_IHM', unassignedRoleIds).subscribe(() => {
        this.alertService.showOperationSuccess();
        this.roleIds = this.roleIds.filter((id) => !unassignedRoleIds.includes(id));
        this.loadAll();
      });
    }
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
